import * as types from './types';

export const optOut = () => ({ type: types.PWA_OPT_OUT, payload: Date.now() });

export default optOut;
